/**
 * Isomorphic retreival of a global variable
 *  - with an optional default value as fallback.
 *
 * For browsers it's read from 'window'
 * For node.js it's read from 'global'
 *
 * @param {string} name - The global variable to lookup
 * @param {any} defaultValue - if [name] is null, emtpy or undefined then defaultValue will be returned
 */
const globalVar = (name: string, defaultValue: any) => {
  const globalObj = getGlobal();
  return globalObj[name] || defaultValue;
};

/**
 * Resolve the global var for the current runtime, node or browser
 */
const getGlobal = () => {
  return isNode ? global : window || {};
};

const hasProcess = typeof process === "object" && process.env;

const isNode = hasProcess && Object.prototype.toString.call(process) === "[object process]";

const applicationSettingsKey = "__application__";

/**
 * Environment variables on the global __application__ object
 * populated by the server environment
 */
const ENVIRONMENT_VAR = {
  HostingPath: "hostingPath",
  ApiBaseUrl: "apiBaseUrl",
  ApplicationUrl: "applicationUrl",
  OidcServiceUrl: "oidcServiceUrl",
  OidcClientId: "oidcClientId",
  OidcScope: "oidcScope",
  OidcDefaultProviderId: "oidcDefaultProviderId",
  OidcRedirectUri: "oidcRedirectUri",
  OidcPostLogoutRedirectUri: "oidcPostLogoutRedirectUri",
  PolicyValidationEndpoint: "policyValidationEndpoint",
  AdminPanelVersion: "adminPanelVersion",
  MaxZipFileSizeInMegabytes: "maxZipFileSizeInMegabytes"
};

const getEnvironmentVariable = (name: string) => {
  const settings = globalVar(applicationSettingsKey, {});
  return settings[name];
};

export const applicationUrl = getEnvironmentVariable(ENVIRONMENT_VAR.ApplicationUrl);
export const oidcServiceUrl = getEnvironmentVariable(ENVIRONMENT_VAR.OidcServiceUrl);
export const oidcClientId = getEnvironmentVariable(ENVIRONMENT_VAR.OidcClientId);
export const oidcScope = getEnvironmentVariable(ENVIRONMENT_VAR.OidcScope);
export const oidcDefaultProviderId = getEnvironmentVariable(ENVIRONMENT_VAR.OidcDefaultProviderId);
export const adminPanelBasePath = getEnvironmentVariable(ENVIRONMENT_VAR.HostingPath);
export const apiBaseUrl = getEnvironmentVariable(ENVIRONMENT_VAR.ApiBaseUrl);
export const showJsonForm = false;
export const oidcRedirectUri = getEnvironmentVariable(ENVIRONMENT_VAR.OidcRedirectUri);
export const oidcPostLogoutRedirectUri = getEnvironmentVariable(
  ENVIRONMENT_VAR.OidcPostLogoutRedirectUri
);
export const policyValidationEndpoint = getEnvironmentVariable(
  ENVIRONMENT_VAR.PolicyValidationEndpoint
);
export const adminPanelVersion = getEnvironmentVariable(ENVIRONMENT_VAR.AdminPanelVersion);
export const maxZipFileSizeInMegabytes = Number.parseInt(
  getEnvironmentVariable(ENVIRONMENT_VAR.MaxZipFileSizeInMegabytes) ?? 0
);
export const applicationRootPath =
    typeof adminPanelBasePath === "string" && adminPanelBasePath.length > 0
      ? adminPanelBasePath
      : "/";
